/**
 * Admin-side agent administration. Mirrors `iElect.ServiceDefaults` `ActionKeys.ManageAgents`.
 *
 * The backend row has existed since the permission bootstrap first ran; only the frontend
 * catalogue was missing the literal, so adding it here is inert server-side — no seed
 * step, no forced re-login.
 *
 * NOT the `ACTIONS_PARTY_AGENT` family (`party_agent_ec8a`…), which are the tokens a field
 * agent carries. A Party Agent holds neither of the keys `AgentCoverageController` accepts
 * and gets an empty-bodied 403 from it.
 */
export const ACTIONS_MANAGE_AGENTS = {
	MANAGE_AGENTS: 'manage_agents',
} as const;
